<template>
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.2361 11.8467C20.2361 11.3893 19.8539 11.0247 19.3971 11.0461C18.9696 11.0662 18.6333 11.4187 18.6333 11.8467V18.2048C18.6333 18.6166 18.5207 18.9097 18.3294 19.1002C18.1379 19.2909 17.8488 19.3973 17.4575 19.3973H5.77021C5.37451 19.3973 5.08809 19.2907 4.90004 19.1009C4.71181 18.9109 4.60282 18.6178 4.60282 18.2048V11.8467C4.60282 11.4187 4.26651 11.0662 3.83899 11.0461C3.38213 11.0247 3 11.3893 3 11.8467L3.00003 18.28C3.00003 19.1615 3.22485 19.8479 3.69549 20.3129C4.16586 20.7777 4.86022 21 5.75349 21H17.4826C18.3759 21 19.0702 20.7777 19.5406 20.3129C20.0112 19.8479 20.2361 19.1615 20.2361 18.28V11.8467Z"
      :fill="disable ? '#999BA3' : '#1D1D1F'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.825 2.78048L10.825 11.3662L10.8615 12.2827L10.5368 11.9385L9.26779 10.586C9.12423 10.4231 8.92132 10.3433 8.72123 10.3433C8.31229 10.3433 7.98253 10.6469 7.98253 11.0653C7.98253 11.2851 8.07959 11.4496 8.22079 11.5908L11.0473 14.317C11.2338 14.5032 11.407 14.5795 11.6222 14.5795C11.8302 14.5795 12.0031 14.5017 12.1962 14.3178L15.0219 11.5924L15.0235 11.5908C15.1682 11.4461 15.2534 11.2811 15.2534 11.0653C15.2534 10.6504 14.9439 10.3433 14.5231 10.3433C14.3341 10.3433 14.1133 10.4213 13.9681 10.5862L12.7076 11.9385L12.3743 12.2865L12.411 11.3714L12.411 2.78048C12.411 2.35733 12.0515 2 11.6222 2C11.1949 2 10.825 2.35527 10.825 2.78048Z"
      :fill="disable ? '#999BA3' : '#1D1D1F'"
    />
  </svg>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'IconDownload',
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
